import { Stack } from "@mui/material";
import { CopyWebhookUrl } from "./CopyWebhookUrl";
import { useGlobalStore } from "controller";
import { ChooseDefaultBoard } from "./ChooseDefaultBoard";

export const CopyWebhookUrlAndChooseDefaultBoard = ({
  chooseBoardRef,
}: {
  chooseBoardRef: any;
}) => {
  const mspId = useGlobalStore((state) => state.mspId);
  return (
    <Stack gap="28px">
      <CopyWebhookUrl
        webhookUrl={`${import.meta.env.VITE_APP_INTEGRATION_BASE_URL}/datto/webhook/alert/${mspId}`}
      />
      <ChooseDefaultBoard ref={chooseBoardRef} />
    </Stack>
  );
};
